module.exports = __webpack_public_path__ + "static/mubashira-5135088584a5cda9849ceae4779d7b49.jpeg";